import React, { ComponentProps, FunctionComponent } from "react";

const PaperShieldIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M35.5932 18.8671L33.7465 17.0203L33.7482 17.0221C33.4886 16.7625 33.1355 16.6153 32.7686 16.6153H28.6148V3.23135C28.6061 1.45041 27.1644 0.0104123 25.3851 0H3.23135C1.45041 0.0103848 0.0104123 1.45036 0 3.23135V32.7686C0.0103848 34.5495 1.45037 35.9895 3.23135 35.9999H25.3851C25.8075 35.9947 26.2246 35.8926 26.6036 35.704C26.8113 35.723 27.0225 35.723 27.2302 35.704C27.7303 35.7057 28.2236 35.5932 28.6702 35.3717L30.1292 34.6326V34.6343C31.8963 33.7585 33.3831 32.4051 34.4198 30.728C35.4583 29.0509 36.0051 27.1159 36 25.1444V19.8465C36 19.4796 35.8528 19.1267 35.5932 18.8671ZM3.23139 33.2307C2.97524 33.2307 2.76927 33.0248 2.76927 32.7686V3.23138C2.76927 2.97523 2.97522 2.76925 3.23139 2.76925H25.3852C25.5063 2.76925 25.624 2.81772 25.7106 2.90425C25.7971 2.99079 25.8456 3.10849 25.8456 3.23137V16.6154H21.6917C21.3248 16.6154 20.9735 16.7625 20.7139 17.0221L18.8671 18.8688V18.8671C18.6075 19.1267 18.4621 19.4798 18.4621 19.8467V25.219C18.4639 25.6759 18.495 26.1311 18.5539 26.5846C18.5469 26.7196 18.5469 26.8546 18.5539 26.9913C18.5539 27.3046 18.6646 27.6005 18.7391 27.9138C18.7737 28.0574 18.8169 28.1993 18.8671 28.3378C18.9571 28.6684 19.0748 28.9886 19.2185 29.2984C19.2479 29.3936 19.2842 29.487 19.3292 29.5753C19.4971 29.9769 19.6944 30.3663 19.9194 30.7384L20.1219 31.0153H20.1237C20.2967 31.2922 20.4888 31.5571 20.6948 31.8097L20.9717 32.1611C21.1742 32.4017 21.3958 32.6232 21.6173 32.8448L21.9133 33.1217L22.024 33.2325L3.23139 33.2307ZM33.2307 25.219C33.2359 26.6763 32.8327 28.1077 32.0659 29.3469C31.2992 30.5879 30.2002 31.5882 28.8917 32.2338L27.4326 32.9729H27.4344C27.3046 33.0282 27.1575 33.0282 27.0276 32.9729H26.9359L25.6067 32.3082C23.2926 31.1677 21.6952 28.954 21.3421 26.3994C21.3144 26.0307 21.3144 25.6603 21.3421 25.2917V20.4923L22.3753 19.459H32.3082L33.3415 20.4923L33.2307 25.219Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M6.923 8.30829H21.6916C22.4566 8.30829 23.0762 7.68869 23.0762 6.92367C23.0762 6.15866 22.4566 5.53906 21.6916 5.53906H6.923C6.15799 5.53906 5.53839 6.15866 5.53839 6.92367C5.53839 7.68869 6.15799 8.30829 6.923 8.30829Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M6.923 13.8464H21.6916C22.4566 13.8464 23.0762 13.2268 23.0762 12.4618C23.0762 11.6967 22.4566 11.0771 21.6916 11.0771H6.923C6.15799 11.0771 5.53839 11.6967 5.53839 12.4618C5.53839 13.2268 6.15799 13.8464 6.923 13.8464Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M14.3082 16.6162H6.923C6.15799 16.6162 5.53839 17.2358 5.53839 18.0008C5.53839 18.7658 6.15799 19.3854 6.923 19.3854H14.3082C15.0715 19.3854 15.6928 18.7658 15.6928 18.0008C15.6928 17.2358 15.0715 16.6162 14.3082 16.6162Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M29.0767 22.5593L26.3075 25.2732L25.385 24.4044C25.153 24.0478 24.7706 23.8176 24.3483 23.7795C23.9242 23.7415 23.5071 23.899 23.2146 24.2088C22.9238 24.5168 22.7906 24.9426 22.8529 25.3632C22.9169 25.7838 23.1696 26.1524 23.5383 26.3618L25.385 28.2086C25.925 28.7486 26.8008 28.7486 27.3408 28.2086L31.0342 24.5151C31.5413 23.9699 31.5275 23.1202 30.9996 22.5923C30.4717 22.0661 29.6218 22.0505 29.0767 22.5593Z",
    })
  );
};

const ForwardRef = React.forwardRef(PaperShieldIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
